import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormBuilder, Validators } from '@angular/forms';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';

@Component({
  selector: 'app-verifyonspotmsme',
  templateUrl: './verifyonspotmsme.component.html',
  styleUrl: './verifyonspotmsme.component.css'
})
export class VerifyonspotmsmeComponent {
  private _formBuilder = inject(FormBuilder);
  data: any[];
  formData: any;
  eventId: any;

  Verifyonspot = this._formBuilder.group({
    udyamRegistrationNumber: [
      //'UDYAM-MH-02-',
      'UDYAM-MH-',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.udyamNumber)
      ]),
    ],
    ownersMobileNumber: [
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.mobilePattern)
      ])
    ],
  });

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.formData = history.state.formData;      
    });

    this.eventId = this.formData.UniqueEventId

    if (this.formData) {
      this.Verifyonspot.get('udyamRegistrationNumber')?.setValue(this.formData.UdyamNumber);
      this.Verifyonspot.get('udyamRegistrationNumber')?.disable();
      this.Verifyonspot.get('ownersMobileNumber')?.setValue(this.formData.MobileNumber);
      this.Verifyonspot.get('ownersMobileNumber')?.disable();
    }    
  }  
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private commonService: CommonService, private router: Router,) {
    this.data = [];
  }

  get f() {
    return this.Verifyonspot.controls;
  }

  //This method is used with Udyam API Integration
  verifyUser() {
    if (this.Verifyonspot.invalid) {
      this.toastrService.error("Invalid form. Please fill out all required fields correctly.");
      return;
    }

    const { udyamRegistrationNumber, ownersMobileNumber } = this.Verifyonspot.controls;

    if (udyamRegistrationNumber.value && ownersMobileNumber.value) {
      const formDatavalue = {
        udyamRegistrationNumber: udyamRegistrationNumber.value,
        ownersMobileNumber: ownersMobileNumber.value,
        uniqueEventId: this.eventId
      };

      this.apiService.postRequest(API_ENDPOINTS.IA.VALIDATEUNREGISTEREDMSME, formDatavalue).subscribe(
        res => {
          if (res.status) {
            if (res.message === "UNF") {
              this.toastrService.info("This Udyam Number is NOT registered on RAMP portal.");
            }
            if (res.message === "UF") {
              this.apiService.postRequest(API_ENDPOINTS.IA.UPDATEUNREGISTEREDMSME, formDatavalue).subscribe(
                res => {
                  if (res.status) {
                    this.toastrService.info("Udyam Number is Registered on RAMP ");
                    this.router.navigate(['/viewEnrolledParticipants', this.eventId]);
                  }
                }
              );
            }
          }
          
        }
      );
    } 
  }


  goBack(): void {
    this.router.navigate(['/viewAttendedParticipants', this.eventId]);
  }
  
}


